export default __webpack_public_path__ + "static/media/investors-other.73d6b13e.mp3";